import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  ListItem,
  ListIcon,
  ListHeader,
  ListDescription,
  ListContent,
  ListList,
  Transition,
} from 'semantic-ui-react';

import { useNavigation } from './NavigationContext';
import type { NavigationItem } from './types';

interface NavigationDropdownListItemProps {
  item: NavigationItem;
}

const NavigationDropdownListItem = ({ item }: NavigationDropdownListItemProps) => {
  const { isMobileMenuOpen, closeMobileMenu } = useNavigation();
  const [expanded, setExpanded] = useState<boolean>(false);
  const hasChildren = item.items.length > 0;

  return (
    <ListItem className="list-item">
      <div className="list-item__row">
        <div className="list-item__icon">
          <ListIcon
            name={hasChildren ? (expanded ? 'caret down' : 'caret right') : 'circle outline'}
            onClick={hasChildren ? () => setExpanded((p) => !p) : undefined}
            className={hasChildren ? 'is-clickable' : 'is-static'}
          />
        </div>

        <ListContent className="list-item__content">
          <ListHeader
            as={NavLink}
            to={item.url}
            onClick={isMobileMenuOpen ? closeMobileMenu : undefined}
            className="list-item__header"
          >
            {item.title}
          </ListHeader>

          {item.description && (
            <ListDescription className="list-item__description">
              {item.description}
            </ListDescription>
          )}

          {hasChildren && (
            <Transition
              visible={expanded}
              animation="slide down"
              duration={200}
              unmountOnHide
            >
              <ListList className="list-item__sublist">
                {item.items.map((child) => (
                  <NavigationDropdownListItem key={child.url} item={child} />
                ))}
              </ListList>
            </Transition>
          )}
        </ListContent>
      </div>
    </ListItem>
  );
};

export default NavigationDropdownListItem;